<template>
  <div>
    <navigationBar :fill="true" />
    <div class="width-1200">
      <breadcrumb />
    </div>
    <div class="width-1200" style="margin-top: 50px;">
<!--      <navStepList3 :current="step" />
      <template v-if="step === 1">
        <div class="b-section main">
          <div>
            <div>
              <div class="for-label" style="margin-bottom: 15px;">手机号码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" v-model.trim="form.name" clearable placeholder="请输入手机号码" />
              <div class="for-label" style="margin-bottom: 15px;">验证码：</div>
              <div class="width-500" style="display: flex;">
                <Input
                    class="bg-color-242631 height-44  login-input"
                    type="text"
                    placeholder="请输入验证码"
                    clearable
                    v-model="form.code"
                    style="width: 400px"
                >
                </Input>
                <div style="margin-left: 20px;">
                  <identify
                      :identify-code="identifyCode"
                      :content-height="44"
                      @reloadEvent="reloadCodeEvent"
                  />
                </div>

              </div>
            </div>
            <Button class="next-btn" type="info" :loading="loading1" @click="handleSubmit(1)" ghost>下一步</Button>
          </div>
        </div>
      </template>
      <template v-if="step === 2">
        <div class="b-section main">
          <div>
            <div class="t-tips">为了你的帐号安全，请完成身份验证</div>
            <div>
              <div class="for-label" style="margin-bottom: 15px;">手机号码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" disabled v-model.trim="account" clearable placeholder="请输入手机号码" />
              <div class="for-label" style="margin-bottom: 15px;">短信验证码：</div>
              <div class="width-500" style="display: flex;">
                <Input
                    class="bg-color-242631 height-44  login-input"
                    type="text"
                    placeholder="请输入验证码"
                    clearable
                    v-model="form.code"
                    style="width: 400px"
                    @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
                >
                </Input>
                <div style="margin-left: 20px;">
                  <smsBtn
                      ref="smsBtn"
                      height="44px"
                      @tap="getCodeEvent"
                      style="width: 120px"
                  ></smsBtn>
                </div>

              </div>
            </div>
            <Button class="next-btn" type="info" :loading="loading2" @click="handleSubmit(2)" ghost>下一步</Button>
          </div>
        </div>
      </template>
      <template v-if="step === 3">
        <div class="b-section main">
          <div>
            <div class="t-tips">为了你的帐号安全，请完成身份验证</div>
            <div>
              <div class="for-label" style="margin-bottom: 15px;">手机号码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" disabled v-model.trim="account" clearable placeholder="请输入手机号码" />
              <div class="for-label" style="margin-bottom: 15px;">新密码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" type="password"  v-model.trim="form.password" clearable placeholder="请输入新密码" />
              <div class="for-label" style="margin-bottom: 15px;">确认新密码：</div>
              <Input class="bg-color-242631 height-44 login-input" style="margin-bottom: 20px;" type="password"  v-model.trim="form.confirmPassword" clearable placeholder="请输入确认新密码" />
            </div>
            <Button class="next-btn" type="info" :loading="loading3" @click="handleSubmit(3)" ghost>下一步</Button>
          </div>
        </div>
      </template>
      <template v-if="step === 4">
        <div class="b-section main">
          <div>
            <div style="text-align: center;">
              <img src="@/assets/image/order-success-icon.png" />
            </div>
            <div class="s-tips">恭喜您，密码重置成功！</div>
            <Button class="next-btn" type="info" ghost to="/login">立即登录</Button>
          </div>
        </div>
      </template>-->
      <div class="section">
        <div class="content">
          <div class="verify-section">
            <div class="row">
              <div class="name">邮箱：</div>
              <div>{{ info.email }}</div>
            </div>
            <div class="row">
              <div class="name">认证状态：</div>
              <div>{{ info.verifyStatus | verifyStatus }}</div>
            </div>
            <div class="row">
              <div class="name">说明：</div>
              <div>{{ info.message }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footBar />
  </div>
</template>

<script>
import footBar from "components/footBar.vue";
import navigationBar from "components/navigationBar";
import breadcrumb from "components/breadcrumb";
import { userVerifyEmail } from "api/user.js";
export default {
  name: "sige",
  components: {
    breadcrumb,
    navigationBar,
    footBar
  },
  filters: {
    verifyStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      info: {},
    };
  },
  created() {
    if (!this.$route.query.key) {
      this.$Message.warning("认证秘钥,不存在请获取密钥！");
      return false;
    }
    this.req_userVerifyEmail();
  },
  methods: {
    req_userVerifyEmail() {
      const parms = {
        key: this.$route.query.key,
      };
      userVerifyEmail(parms).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.info = data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.main{
  .flex(center, center);
  min-height: 444px;
}
.next-btn{
  display: block;
  height: 56px;
  line-height: 56px;
  width: 240px;
  margin: 50px auto 0;
  // 主流程按钮：实心蓝底白字
  &.ivu-btn{
    background-color: @brand;
    border-color: @brand;
    color: #fff;
  }
  &.ivu-btn:hover{
    background-color: @brand-hover;
    border-color: @brand-hover;
    color: #fff;
  }
  &.ivu-btn:active{
    background-color: @brand-deep;
    border-color: @brand-deep;
    color: #fff;
  }
}
/deep/.sms-btn{
  margin-left: 20px;
  .ivu-btn{
    width: 120px;
    background-color: #c4332e;
    color: #fff;
    border-color:#c4332e;
  }

}
.t-tips{
  font-size: 27px;
  line-height: 60px;
  margin-bottom: 30px;
  color: #C4332E;
  text-align: center;
}
.s-tips{
  font-size: 27px;
  line-height: 60px;
  margin: 15px 0 0;
  color: #fff;
  text-align: center;
}
.section {
  background-color: #FFF;
  padding: 210px 0 80px;
  .content {
    width: 1200px;
    margin: 0 auto;
  }
}
.verify-section {
  width: 400px;
  height: 400px;
  margin: 0 auto;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .name {
    min-width: 80px;
    font-size: 18px;
    line-height: 30px;
    color: #333;
  }
  .name.required {
    &::before {
      content: "*";
      color: #ed1d33;
      margin-right: 5px;
    }
  }
  .label {
    font-size: 18px;
    line-height: 30px;
    color: #333;
  }
}
</style>
